import * as actionTypes from '../config/actionTypes';
import axios from '../config/axios';
import * as routes from '../config/routes';
import {
  getAuthHeaders,
  manageAuthActionError,
} from '../auth/actions';
import {
  changeInputHandler,
} from '../common/utility';

export const toggleLoading = () => {
  return {
    type: actionTypes.TOGGLE_SEARCH_LOADING,
  };
};


export const showError = (error) => {
  return {
    type: actionTypes.SHOW_SEARCH_ERROR,
    payload: error,
  };
};


export const onUnmount = () => {
  return {
    type: actionTypes.UNMOUNT_SEARCH,
  };
};


export const updateInputs = (section, data) => {
  return {
    type: actionTypes.UPDATE_SEARCH_INPUTS,
    payload: { section: section, data: data }  // eslint-disable-line
  };
};


export const inputChangedHandler = (event, field, section, inputs) => {
  return (dispatch) => {
    const updatedControls = changeInputHandler(
        event,
        inputs,
        field,
    );
    dispatch(updateInputs(section, updatedControls));
  };
};


export const showResults = (data) => {
  return {
    type: actionTypes.SHOW_SEARCH_RESULTS,
    payload: data,
  };
};


export const searchProfiles = (token, siteID) => {
  return (dispatch) => {
    dispatch(toggleLoading());
    const url = '/search/profiles';

    let parsed = window.localStorage.getItem('SELECTED_VALUES');
    if (parsed) {
      parsed = JSON.parse(parsed);
      parsed.site_id = [siteID];
      axios.post(url, parsed, getAuthHeaders(token))
        .then((response) => {
          dispatch(toggleLoading());
          dispatch(showResults(response.data));
        })
        .catch((error) => {
          dispatch(manageAuthActionError(error, token));
          if (error.response.data && error.response.data.detail) {
            dispatch(showError(error.response.data.detail));
          }
          dispatch(showError('Something went wrong! Please contact tech support'));
          dispatch(toggleLoading());
        });
    }
  };
};


// export const getPartnerSearchForm = (token, section, inputs) => {
//   return (dispatch) => {
//     dispatch(toggleLoading());
//     axios.get('/search/get-partner-search', getAuthHeaders(token))
//       .then((response) => {
//         const updatedControls = {};

//         Object.keys(response.data).map((key) => {
//           const input = { ...inputs[key] };
//           if (input.type) {
//             input.value = response.data[key];
//             updatedControls[key] = input;
//           }
//           return null;
//         });

//         dispatch(updateInputs(section, updatedControls));
//         dispatch(toggleLoading());
//       })
//       .catch((error) => {
//         dispatch(manageAuthActionError(error, token));
//         dispatch(toggleLoading());
//       });
//   };
// };


export const getSearchPreSelection = (siteId, token, section, inputs) => {
  return (dispatch) => {
    dispatch(toggleLoading());
    axios.get(`/search/get-preselection-search?site_id=${siteId}`, getAuthHeaders(token))
      .then((response) => {
        const updatedControls = {};

        Object.keys(response.data).map((key) => {
          const input = { ...inputs[key] };
          if (input.type && response.data[key] !== null) {
            input.value = response.data[key];
            updatedControls[key] = input;
          }
          return null;
        });

        dispatch(updateInputs(section, updatedControls));
        dispatch(toggleLoading());
      })
      .catch((error) => {
        dispatch(manageAuthActionError(error, token));
        dispatch(toggleLoading());
      });
  };
};


export const submitHandler = (event, inputs, history) => {
  return () => {
    event.preventDefault();

    const singleFields = ['profile_id', 'from_age', 'to_age', 'from_height', 'to_height', 'first_name', 'last_name'];

    const selectedValues = {};

    Object.keys(inputs).forEach((key) => {
      const values = inputs[key].value;
      if (Array.isArray(values) && values.length > 0) {
        selectedValues[key] = [];
        values.forEach(val => selectedValues[key].push(val.value));
      } else if (!Array.isArray(values) && values !== '' && values !== null && values !== undefined) {
        if (singleFields.includes(key)) {
          selectedValues[key] = [values];
        } else {
          selectedValues[key] = [values.value];
        }
      }
    });
    window.localStorage.setItem('SELECTED_VALUES', JSON.stringify(selectedValues));
    history.push(routes.SEARCH_RESULTS);
  };
};


export const searchActionLoading = () => {
  return {
    type: actionTypes.SEARCH_ACTION_LOADING,
  };
};


export const showActionMessage = (error) => {
  return {
    type: actionTypes.SEARCH_ACTION_MESSAGE,
    payload: error,
  };
};


export const saveSearch = (token) => {
  return (dispatch) => {
    let data = null;
    data = window.localStorage.getItem('SELECTED_VALUES');
    if (!data) {
      data = '{}';
    } else {
      const parsed = JSON.parse(data);
      delete parsed.page;
      data = JSON.stringify(parsed);
    }
    dispatch(searchActionLoading());
    axios.post('/search/saved-search', { data }, getAuthHeaders(token))
      .then(() => {
        dispatch(searchActionLoading());
        dispatch(showActionMessage('Search Saved! Please close this dialog!'));
      })
      .catch((error) => {
        if (error.response.data && error.response.data.detail) {
          dispatch(showActionMessage(error.response.data.detail));
        }
        dispatch(searchActionLoading());
      });
  };
};


export const deleteSavedSearch = (token, id) => {
  return () => {
    const url = `/search/saved-search/${id}`;
    axios.delete(url, getAuthHeaders(token))
      .then(() => {
        window.location.reload();
      })
      .catch(() => {
        alert('Something went wrong!');
      });
  };
};


export const showSavedSearch = (data) => {
  return {
    type: actionTypes.SHOW_SAVED,
    payload: data,
  };
};


export const getSavedSearch = (token) => {
  return (dispatch) => {
    dispatch(toggleLoading());
    axios.get('/search/saved-search', getAuthHeaders(token))
      .then((response) => {
        dispatch(toggleLoading());
        dispatch(showSavedSearch(response.data));
      })
      .catch((error) => {
        dispatch(manageAuthActionError(error, token));
        if (error.response.data && error.response.data.detail) {
          dispatch(showError(error.response.data.detail));
        }
        dispatch(showError('Something went wrong! Please contact tech support'));
        dispatch(toggleLoading());
      });
  };
};



// WEBPACK FOOTER //
// ./src/search/actions.js